/**
 * Hook to get the studio group from the environment variables.
 * Reason for this hook is to be able to mock the studio group easily in tests.
 */
export default function useStudioGroup() {
  return process.env.REACT_APP_P_STUDIO_GROUP;
}
